// Common to all (or just a place to drop a builder, we could use elsewhere)
import {fetcher} from "./restClient.js";

/**
 * fetch a single entity and display
 *
 * called by both panes
 * @param url
 * @return {Promise<Object|never>}
 */
export const fetchOne = async (url = dataUrl??'') => {
    try {
        // get details and reset them first
        const form = document.getElementById('detail').querySelector('form');
        const subs = document.getElementById('subDetail');
        removeSubs();
        form.empty();
        // fetch all
        const [hoofd, sub] = await Promise.all([
            fetcher(url),
            fetcher(url + '/subentiteiten')
        ]);
        console.group('hoofd'); console.log(hoofd);
        console.group('subs'); console.log(sub);
        console.groupEnd(); console.groupEnd();
        // add subs
        if (sub.length > 0 && hoofd.length === undefined) {
            if (subs.lastElementChild.children.length>0) subs.lastElementChild.replaceChildren(); // Oh, why I always perform extra checks?
            [...sub].map(s => subs.lastElementChild.append(createCard(s)));
            subs.classList.contains('collapsed') && subs.classList.remove('collapsed');
        }
        // fill in form
        form.fill(hoofd, url);
        return Promise.resolve();
    } catch (e) {
        removeSubs();
        console.error(url + ' not serving? \n'+e.message); console.trace(e);
        return Promise.reject(e);
    }
}
/**
 * little helper to collapse and replace subs
 */
export const removeSubs = () => {
    const subs = document.getElementById('subDetail');
    if (subs.classList.contains('collapsed')) {
        subs.lastElementChild.replaceChildren();
    } else {
        subs.classList.add('collapsed');
        subs.addEventListener('animationend', (e) => {
            if (subs.classList.contains('collapsed')) {
                subs.lastElementChild.replaceChildren();
            }
            e.stopPropagation();
        }, {once: true});
    }
}
/**
 * create Bootstrap card for a sub
 * @param item a single SubEntity
 * @param caption a caption if you desire
 * @return {HTMLDivElement} a bootstrap card
 */
const createCard = (item, caption = '') => {
    const col = document.createDocumentFragment().appendChild(document.createElement('div')); // card-container
    const card = col.appendChild(document.createElement('article')); // card-container
    card.title = caption || 'infoCard|'+item.applicatie+'|'+item.id;
    let el = card.appendChild(document.createElement('h4')); // card-header html5 compliant title
    el.appendChild(document.createElement('span')).innerHTML = item.applicatie;
    el.appendChild(document.createElement('span')).innerHTML = '|'+item.id;
    el = card.appendChild(document.createElement('div')).appendChild(document.createElement('ul')); // card-body
    el.appendChild(document.createElement('li')).appendChild(document.createElement('p')).innerHTML = 'app: '+item.applicatie;
    el.appendChild(document.createElement('li')).innerHTML = 'rol: '+item.rol;
    el = card.appendChild(document.createElement('div')); // card-fppter
    el.appendChild(document.createElement('small')).innerHTML = (new Date(item.grantedDate)).toLocaleDateString("nl-BE",  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    return col;
}
/**
 * create Bootstrap dismissible alert
 * @param message
 * @param type
 * @return {HTMLDivElement}
 */
export const createAlert = (message = 'the message you wish to convey', type = 'danger') => {
    const alert = document.createDocumentFragment().appendChild(document.createElement('div'));
    alert.classList.add('alert', 'alert-'+type, 'alert-dismissible','fade','show');
    alert.setAttribute('role', 'alert');
    // alert.appendChild(new Text(message));
    alert.appendChild(document.createTextNode(new DOMParser().parseFromString(message, "text/html").documentElement.textContent));
    // alert.innerHTML = message;
    const button = alert.appendChild(document.createElement('button'));
    button.classList.add('btn-close');
    button.setAttribute('data-bs-dismiss', 'alert');
    button.setAttribute('aria-label', 'Close');
    new bootstrap.Alert(alert);
    alert.addEventListener('close.bs.alert', () => alert.nextElementSibling.focus());
    return alert;
}
export const removeAlerts = () => {
    document.querySelectorAll('.alert').forEach(alert => bootstrap.Alert.getInstance(alert).close());
}
/**
 * enhanced table /w overview
 *
 * (Used to be part of several panes - and accommodates them still
 * @param caption string: default 'Personen'
 * @param id string: default 'hoofdEntiteiten'
 * @param del boolean: add a delete button to each row
 * @param headers array: colum headers = number of cols
 * @return {HTMLTableElement}
 */
export const createTable = ({caption = 'Personen', id = 'hoofdEntiteiten', del = true, headers = []} = {}) => {
    const table = document.createDocumentFragment().appendChild(document.createElement('table'));
    table.setAttribute('id', id);
    caption ? table.createCaption().innerHTML = caption : null;
    if (headers.length === 0) headers = ['id', 'name', 'department'];
    table.createTHead().insertRow(-1);
    let row = table.tHead.rows.item(0);
    headers.forEach(i => row.insertAdjacentElement("beforeend", document.createElement('th')).innerHTML = i);
    if (del) row.insertAdjacentElement("beforeend", document.createElement('th'));
    table.createTBody();
    /**
     * a method for this table
     * creates and adds a row based on an Entity
     * @param entiteit Object using attributes corresponding table headers
     * @param del boolean (delete buttons) default true
     * @return {HTMLTableRowElement}
     */
    table.addFillRow = (entiteit, del = true) => {
        table.tBodies.item(0).insertRow(-1);
        let row = table.tBodies.item(0).rows.item(table.tBodies.item(0).rows.length - 1);
        row.dataset[headers.at(2)] = entiteit[headers.at(2)];
        headers.forEach(i => row.insertCell(-1).innerHTML = entiteit[i] ?? null);
        if (entiteit?._links.self.href) {
            row.cells.item(0).dataset.location = entiteit._links.self.href;
            row.cells.item(0).classList.add((id.startsWith('hoofd') ? 'hoofd' : 'sub') + '-' + entiteit[headers.at(0)]);
        }
        if (del) {
            row.insertCell(-1);
            const icon = document.createDocumentFragment().appendChild(document.createElement('button'));
            icon.title = 'delete '+entiteit.name;
            icon.appendChild(document.createElement('i')).classList.add('bi', 'bi-trash');
            row.cells.item(3).insertAdjacentElement("afterbegin", icon);
        }
        return row;
    }
    /**
     * a method for this table
     * drop all tbody rows
     */
    table.empty = () => {
        // let nr = table.tBodies.item(0).rows.length;
        // while(nr--) table.tBodies.item(0).rows.item(nr).remove();
        let tbody = table.tBodies.item(0);
        while (tbody.hasChildNodes()) tbody.removeChild(tbody.lastChild);
    }
    return table;
}
/**
 * enhanced HTMLFormElement + bootstrap components
 * @return {HTMLFormElement}
 */
export const createForm = (prefix = 'f_') => {
    const form = document.createDocumentFragment().appendChild(document.createElement('form'));
    form.method="POST";
    form.autocomplete="off";
    form.noValidate=true; // going bs on your a..
    form.setAttribute('aria-label','new');

    /**
     * bootstrap minded input creator, /w wrapper, span en label for multiple applications
     * @param labelText
     * @param type checkbox, select, ...
     * @param parentNode
     * @param options
     * @return {HTMLElement} the input element NOT the wrapper
     */
    form.create_input = (labelText = '', {type = 'text', parentNode = form?.firstChild?.lastChild??form, options = {}} = {}) => {
        const container = parentNode.appendChild(document.createElement('div')); // flow container
        const span = container.appendChild(document.createElement('span')); // span potential input-group
        const input = container.appendChild(document.createElement((type.toLowerCase() === 'select')?type:'input')); // actual form element
        const label = container.appendChild(document.createElement('label')); // label
        if (type.toLowerCase() === 'select') {
            input.appendChild(new Option('', '', true));
            options = Object.keys(options).map(k => input.appendChild(new Option(k, options[k])));
        } else {
            input.type = type;
            if (type.toLowerCase() === 'checkbox') {
                input.classList.add('form-check-input');
                input.parentElement.classList.add('form-check', 'form-switch');
                input.setAttribute('role','switch');
                input.setAttribute('value',true);
            }
        }
        // no aria describe by / label / labeled-by needed since we attach a label /w for
        input.name = input.placeholder = labelText.replace(/\s/g, ''); // input name + placeholder
        span.innerHTML = label.innerHTML = labelText; // (span + label) Text
        input.id = label.htmlFor = span.dataset.htmlFor = prefix + labelText.replace(/\s/g, '') + '_' + [...form.elements].filter(el => !(el instanceof HTMLFieldSetElement)).length; // corresponding referencing
        return input;
    }
    /**
     * bootstrap minded button creator
     * @param labelText
     * @param parentNode
     * @param bsToggle bootstrap toggle support
     * @param theme bootstrap btn css color theme
     * @return {HTMLButtonElement}
     */
    form.create_button = (labelText = '', { parentNode = form?.firstChild?.lastChild??form, theme = 'btn-outline-primary', bsToggle = false } = {}) => {
        let el = parentNode.appendChild(document.createElement('button'));
        el.classList.add(theme);
        el.name = el.innerHTML = labelText;
        el.id = prefix + labelText.replace(/\s/g, '');
        if (bsToggle) { // we need a toggling button /w aria-pressed indication? bootstrap.Button.getInstance(el).toggle();
            el.dataset.bsToggle = "button";
            new bootstrap.Button(el);
        }
        return el;
    }
    return form;
}
/**
 * add tabbed navigation, and get your collapsing navbar back after you click-it
 * add navigational aids (Popovers and Tooltips)
 */
export const addNav = () => {
    const triggerTabList = [].slice.call(document.querySelectorAll('nav div ul a'));
    const navBar = new bootstrap.Collapse(document.querySelector('#navbarToggler'), {toggle: false});
    const navToggler = document.querySelector('nav div button[data-bs-toggle="collapse"]').attributes.getNamedItem('aria-expanded');
    triggerTabList.forEach(function (triggerEl) {
        const tabTrigger = new bootstrap.Tab(triggerEl);
        triggerEl.addEventListener('click', function (event) {
            event.preventDefault();
            tabTrigger.show();
            if (navToggler) {
               navBar.hide();
            }
        });
        triggerEl.addEventListener('show.bs.tab', e => window.scrollTo({top:0, left:0, behavior: 'smooth'}));
    });
    bootstrap.Tab.getInstance(triggerTabList.at(0)).show();
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'hover',
            container: 'body',
        });
    });
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl, {
            trigger: 'hover',
            container: 'body',
            delay: { "show": 0, "hide": 100 },
            boundary: document.body
        });
    })
}
